import { create } from "zustand"

import { getPage } from "@/utils/sdk"

export enum GlobalView {
    MAIN,
    RECALL,
}

interface States {
    globalView: GlobalView
}

interface Actions {
    setGlobalView: (payload: States["globalView"]) => void
}

export const useGlobalViewStore = create<States & Actions>((set) => ({
    globalView: getPage() === "recall" ? GlobalView.RECALL : GlobalView.MAIN,
    setGlobalView: (globalView) => set({ globalView }),
}))

export const useGlobalView = () =>
    useGlobalViewStore((state) => state.globalView)
export const useSetGlobalView = () =>
    useGlobalViewStore((state) => state.setGlobalView)
